import React, { Fragment, useEffect, useState } from 'react';
import { useFormikTransferFilters } from '../../../../utils';
import ApproveRequestView from '../Views/ApproveRequestsView';
import {
  useCancelRequest,
  usePetitions,
  usePetitionsById,
} from '../../../../hooks';
import { PetitionsFilter } from '../../../Petitions/types';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';
import TransfersDetailContainer from '../../../Transfers/components/Containers/TransfersDetailContainer';
import GoodsDetailContainer from '../../../Goods/components/Containers/GoodsDetailContainer';
import EntryRequestDetailContainer from '../../../EntryRequests/components/Containers/EntryRequestDetailContainer';
import { useCustomToast } from '../../../../components';

type ModalType = 'refund' | 'transfer' | 'good' | 'entry' | null;

const ApproveRequestsContainer: React.FC = () => {
  const [validateUrl, setValidateUrl] = useState(false);
  const [modalState, setModalState] = React.useState<{
    type: ModalType;
    id?: string;
  }>({ type: null, id: undefined });
  const [authData] = useAtom(authAtom);
  const [filter, setFilter] = React.useState<PetitionsFilter>({
    branch_id: authData?.user.branch_id,
    status_id: '8',
    petitionable_type: [
      authData?.portalPermissions.includes('webportal-goods') && 'GoodPetition',
      authData?.portalPermissions.includes('webportal-entry') && 'EntryPetition',
    ].filter(Boolean).join(','),
  });
  const {
    data: approveRequests,
    isPending: loadList,
    refetch,
  } = usePetitions(filter);

  const { mutateAsync: cancelRequest } = useCancelRequest();
  const { data: petition, isPending: loadById } = usePetitionsById(
    modalState?.id
  ) as any;

  const onViewDetail = (record: any) => {
    if (record?.ticket_type == 'Solicitud de Reintegro') {
      handleModalToggle('refund', record.id);
    }

    if (record?.ticket_type == 'Solicitud de Traslado') {
      handleModalToggle('transfer', record.id);
    }

    if (record?.ticket_type == 'Solicitud de Bienes') {
      handleModalToggle('good', record.id);
    }

    if (record?.ticket_type == 'Solicitud de Entrada') {
      handleModalToggle('entry', record.id);
    }
  };

  const handleModalToggle = (type: ModalType, id?: string) => {
    setModalState((prev) => ({
      type: prev.type === type ? null : type,
      id: id,
    }));
  };

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };

  const handleFilter = async (values: PetitionsFilter) => {
    setFilter({
      ...values,
      petitionable_type: [
        authData?.portalPermissions.includes('webportal-goods') && 'GoodPetition',
        authData?.portalPermissions.includes('webportal-entry') && 'EntryPetition',
      ].filter(Boolean).join(','),
      branch_id: authData?.user.branch_id,
      status_id: '8',
      created_at: values?.created_at
        ? new Date(values.created_at).toISOString().split('T')[0]
        : '',
    });
  };

  const onCancelRequest = async (id: string, reason: string) => {
    const { showToast } = useCustomToast();

    try {
      await cancelRequest({ id, data: { reason } });

      showToast('success', 'Solicitud ha sido anulada.');
    } catch (error) {
      showToast('error', 'Error al anular solicitud.');
    }
  };

  const formik = useFormikTransferFilters({ onSubmit: handleFilter });

  useEffect(() => {
    if(location.pathname === '/approve-request'){
      setValidateUrl(true)
    }else{
    setValidateUrl(false)
    }
  }, [])

  useEffect(() => {
    if (refetch) {
      refetch();
    }
  }, [filter, refetch]);

  return (
    <Fragment>
      <TransfersDetailContainer
        isOpen={modalState.type === 'transfer'}
        OnClose={() => handleModalToggle('transfer')}
        data={petition}
        isLoading={loadById}
        isApproveRequest={true}
      />
      <GoodsDetailContainer
        isOpen={modalState.type === 'good'}
        OnClose={() => handleModalToggle('good')}
        isLoading={loadById}
        data={petition}
        isApproveRequest
        refetch={refetch}
      />
      <EntryRequestDetailContainer
        isOpen={modalState.type === 'entry'}
        OnClose={() => handleModalToggle('entry')}
        data={petition}
        isLoading={loadById}
        isApproveRequest={true}
        isModuleApproveRequest={validateUrl}
        refetch={refetch}
      />

      <ApproveRequestView
        isLoading={loadList}
        data={approveRequests}
        formik={formik}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formik.resetForm();
        }}
        onViewDetail={onViewDetail}
        onCancelRequest={onCancelRequest}
      />
    </Fragment>
  );
};

export default ApproveRequestsContainer;
